import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M15 5H9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 9v3h4l-7 7-7-7h4V9h6z", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowBigDownDash";
const ArrowBigDownDash = memo(themed(Icon));
export {
  ArrowBigDownDash
};
//# sourceMappingURL=arrow-big-down-dash.js.map
